import {FC} from "react";
import IconInfo from "../../../assets/icons/info-italic.svg";
import {Tooltip} from "react-tooltip";
import {SnippetShowThreeIcons} from "./SnippetShowThreeIcons";
import IconDollarFlower from "../../../assets/icons/filter-dollar-active.svg";
import IconWorld from "../../../assets/icons/filter-ball-active.svg";
import IconStar from "../../../assets/icons/icon-star-active.svg";
import IconDone from "../../../assets/icons/done-active.svg";
import IconPotion from "../../../assets/icons/potion-active.svg";
import {Iprojects} from "../../../pages/Esg/EsgDashboard.type";
import {ITehnologyDataSideBar} from "../../../pages/Dashboard/Dashboard.type";
import {ITypeRadar} from "../../../types";

interface IProps {
  title: string;
  tooltip?: string;
  isTopBar?: boolean;
  data?: Iprojects | ITehnologyDataSideBar;
  typeRadar?: ITypeRadar;
  style?: React.CSSProperties;
}

export const TitleBlockTrend: FC<IProps> = ({
  title,
  tooltip,
  isTopBar = false,
  data,
  typeRadar,
  style,
}) => {
  return (
    <div
      style={{
        color: "#ffffff",
        fontSize: 18,
        // textTransform: "uppercase",
        display: "flex",
        alignItems: "center",
        ...style,
      }}
    >
      {title}
      {tooltip && (
        <div
          style={{
            width: 20,
            height: 36,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          data-tooltip-id="tooltip"
          data-tooltip-content={tooltip}
        >
          <img
            src={IconInfo}
            alt={"IconInfo"}
            width="20"
            height="20"
            style={{marginLeft: 10, opacity: 0.8}}
            onMouseOver={(e) => (e.currentTarget.style.opacity = "1")}
            onMouseOut={(e) => (e.currentTarget.style.opacity = "1")}
          />
          <Tooltip
            id="tooltip"
            // className="tooltip"
            style={{
              width: "100%",
              maxWidth: 300,
              fontSize: 13,
              color: "#333",
              fontWeight: 400,
              lineHeight: 1.2,
              backgroundColor: "#fff",
              padding: 8,
              marginLeft: 30,
              marginBottom: -60,
            }}
            place="top-end"
            noArrow
          />
        </div>
      )}
      {isTopBar && (
        <div
          style={{
            maxHeight: 20,
            display: "inline-block",
            fontSize: 10,
          }}
        >
          {typeRadar === "esg" ? (
            <div style={{display: "flex", gap: 10, marginLeft: 10}}>
              <SnippetShowThreeIcons
                countActive={data && "cagr_tier" in data ? data?.cagr_tier : 0}
                imgActive={IconWorld}
                id={1}
                tooltip={"CAGR"}
                size="xs"
              />
              <SnippetShowThreeIcons
                countActive={data && "rank_tier" in data ? data?.rank_tier : 0}
                imgActive={IconStar}
                id={1}
                tooltip={"RANK"}
                size="xs"
              />
              <SnippetShowThreeIcons
                countActive={1}
                imgActive={IconDollarFlower}
                id={1}
                tooltip={"Прогноз мирового рынка к 2030 г."}
                size="xs"
              />
            </div>
          ) : (
            <div style={{display: "flex", gap: 10, marginLeft: 10}}>
              <SnippetShowThreeIcons
                countActive={data && "trl" in data ? data?.trl : 0}
                imgActive={IconPotion}
                id={1}
                tooltip={
                  "Уровень научной зрелости в России (патенты и публикации) за 2023-2026 гг."
                }
                size="xs"
              />
              <SnippetShowThreeIcons
                countActive={
                  data && "potential_volume_tier" in data
                    ? data?.potential_volume_tier
                    : 0
                }
                imgActive={IconDone}
                id={1}
                tooltip={"Есть потенциал роста технологии в России"}
                size="xs"
              />
              <SnippetShowThreeIcons
                countActive={
                  data && "invest_volume_tier" in data
                    ? data?.invest_volume_tier
                    : 0
                }
                imgActive={IconDollarFlower}
                id={1}
                tooltip={
                  "Совокупный объем мировых инвестиций в стартапы за 2023-2026 гг."
                }
                size="xs"
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};
